import styled from 'styled-components';

export const BoxMaterial = styled.div`
  display: flex;
  @media only screen and (max-width: 1090px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 100%;
  }
  width: 410px;
  gap: 30px;
`;

export const Button = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  height: 35px;
  background: #5768FF;
  border-radius: 5px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  &:hover {
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
    background: #3F4CBD;
    border: 1px solid #3F4CBD;
    transition: 0.3s;
  }
`;

export const CardMaterial = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;
  gap: 20px;
  height: 139px;
  max-width : 410px;
  width : 410px;
  @media only screen and (max-width: 1090px) {
      width: 100%;
      height: auto;
  }
  background: #F4F4F4;
  border-radius: 5px;
  flex: none;
  order: 0;
  flex-grow: 1;
`;

export const DescriptionTitle = styled.span`
  height: 24px;
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
`;

export const TitleButton = styled.text`
  color: #FFFFFF;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
`;
